"use client";

import { motion } from "framer-motion";
import { Mail, Phone, Globe, MapPin, Linkedin, Instagram } from "lucide-react";

const Footer = () => {
  const animationVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <footer className="bg-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-full"></div>
      </div>

      <div className="relative z-10">
        <div className="container mx-auto px-4 py-16">
          <motion.div
            className="max-w-6xl mx-auto"
            variants={animationVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {/* Company Description */}
              <div className="lg:col-span-2">
                <div className="flex items-center gap-3 mb-4">
                  <img
                    src="/Clynox-text-black.png"
                    alt="Logo"
                    className="h-10 w-auto object-contain"
                  />
                </div>
                <p className="text-black-300 mb-6 leading-relaxed">
                  Smart management software for schools, bus fleets, and inventory, built for India.
                </p>
                
                {/* Social Media Links */}
                <div className="flex space-x-4">
                  <motion.a
                    href="https://www.linkedin.com/company/clynox/posts/?feedView=all"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 bg-white/10 rounded-lg text-black-300 hover:text-blue-400 hover:bg-white/20 transition-all duration-300"
                    whileHover={{ scale: 1.1, y: -2 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Linkedin className="h-5 w-5" />
                  </motion.a>
                  <motion.a
                    href="https://www.instagram.com/clynox_solutions/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 bg-white/10 rounded-lg text-black-300 hover:text-pink-400 hover:bg-white/20 transition-all duration-300"
                    whileHover={{ scale: 1.1, y: -2 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Instagram className="h-5 w-5" />
                  </motion.a>
                </div>
              </div>

              {/* Contact Us */}
              <div>
                <h4 className="text-lg font-semibold text-black mb-4">Contact Us</h4>
                <div className="space-y-3">
                  <div className="flex items-center text-black-300">
                    <Phone className="h-5 w-5 mr-3 text-blue-400" />
                    <span>+91-7499070944</span>
                  </div>
                  <div className="flex items-center text-black-300">
                    <Mail className="h-5 w-5 mr-3 text-blue-400" />
                    <span>clynoxofficial@gmail.com</span>
                  </div>
                  <div className="flex items-center text-black-300">
                    <MapPin className="h-5 w-5 mr-3 text-blue-400 flex-shrink-0" />
                    <a
                      href="https://www.google.com/maps/search/?api=1&query=Sector+20,+Faridabad,+Haryana,+India+121002"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-black transition-colors duration-300"
                    >
                      Sector 20, Faridabad, Haryana, India – 121002
                    </a>
                  </div>
                  <div className="flex items-center text-black-300">
                    <Globe className="h-5 w-5 mr-3 text-blue-400" />
                    <span>www.clynox.com</span>
                  </div>
                </div>
              </div>

              {/* Legal */}
              <div>
                <h4 className="text-lg font-semibold text-black mb-4">Legal</h4>
                <ul className="space-y-3">
                  <li>
                    <a
                      href="/privacy-policy"
                      className="text-black-300 hover:text-black transition-colors duration-300"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      href="/terms-conditions"
                      className="text-black-300 hover:text-black transition-colors duration-300"
                    >
                      Terms & Conditions
                    </a>
                  </li>
                  <li>
                    <a
                      href="/refund-policy"
                      className="text-black-300 hover:text-black transition-colors duration-300"
                    >
                      Refund Policy
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          className="border-t border-black/10 py-6"
          variants={animationVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <div className="container mx-auto px-4">
            <div className="text-center">
              <p className="text-black-300 text-sm">
                © 2024 All rights reserved.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
